module.exports = __webpack_public_path__ + "static/img/logo75.1219c2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo75.png
// module id = krCB
// module chunks = 1